export const enum GameRequest {
    SMALL_SPIN = `SMALL_SPIN`,
    SPIN = `SPIN`,
    VS_SPIN = `VS_SPIN`,
    FREE_SPIN = `FREE_SPIN`
}

export const enum GameEvent {
    OPEN_GAME = `OPEN_GAME`,
    SMALL_SPIN = `SMALL_SPIN`,
    SPIN = `SPIN`,
    VS_SPIN = `VS_SPIN`,
    FREE_SPIN = `FREE_SPIN`,
    SPIN_ERROR = `SPIN_ERROR`
}